/* ---- CUSTOM Jump to Section ---- */
document.addEventListener('click', (e) => {
  const trigger = e.target.closest('[data-jump-to-section-id]');
  if (!trigger) return;

  const id = trigger.dataset.jumpToSectionId;

  const target = document.querySelector(
    `[data-anchor-section-id="${id}"]`
  );

  target?.scrollIntoView({ behavior: 'smooth' });
});

/* ---- PDP custom ebook atc ---- */

async function customAddToCartHandler(event) {
  const button = event.target.closest('.custom-add-to-cart-button');
  if (!button) return;

  event.preventDefault();
  event.stopImmediatePropagation();

  /*console.log('[customAddToCart] fired');*/

  const wrapper = document.querySelector('.additional-tests__item-wrapper');
  if (!wrapper) return;

  const uniqueIds = [
    ...new Set(
      Array.from(wrapper.querySelectorAll('.additional-test__checkbox'))
        .filter(cb => cb.checked && cb.dataset.productid)
        .map(cb => Number(cb.dataset.productid))
    ),
  ];

  if (!uniqueIds.length) return;

  if (button.dataset.processing === 'true') return;
  button.dataset.processing = 'true';

  try {
    await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: uniqueIds.map(id => ({
          id,
          quantity: 1,
        })),
      }),
    })        
    .then((response) => response.json())
    .then(async () => {
      const updatedCart = await fetch("/cart.js").then((r) =>
        r.json()
      );
      document.dispatchEvent(
        new CustomEvent("cart:update", {
          bubbles: true,
          detail: {
            resource: updatedCart,
            sourceId: "eBooks",
            data: {
              source: "eBooks",
              itemCount: updatedCart.item_count,
            },
          },
        })
      );
    });

  } catch (e) {
    console.error('[customAddToCart] failed', e);
  } finally {
    button.dataset.processing = 'false';
  }
}

document.removeEventListener('click', customAddToCartHandler, true);
document.addEventListener('click', customAddToCartHandler, true);

/* ------------------------------------------------------------------------------------------------------------- */
/* ----------------------------------------           CART       ----------------------------------------------- */
/* ------------------------------------------------------------------------------------------------------------- */

function cartLoadingSpinner__active() {
  document
  .querySelectorAll('.cart-items__wrapper .spinner-overlay, .cart-page__summary .spinner-overlay')
  .forEach(el => el.hidden = false);
}

function cartLoadingSpinner__deactivate() {
  document
  .querySelectorAll('.cart-items__wrapper .spinner-overlay, .cart-page__summary .spinner-overlay')
  .forEach(el => el.hidden = true);
}


/* --- Cart quantity --- */
// For changing "Main product" Component in Bundle
document.addEventListener('change', async function(e) {
  // Check if the changed element is a quantity dropdown
  if (e.target.classList.contains('custom__quantity-dropdown')) {
        
    const dropdown = e.target;
    const subItem__newQuantity = dropdown.value;
    const oldValue = dropdown.dataset.currentqty;
    const productId = dropdown.dataset.productid;
    const mainProductKey = dropdown.dataset.mainproductkey;
    
    const isIncrease = Number(subItem__newQuantity) > Number(oldValue);
    
    // console.log('Quantity changed:', {value: subItem__newQuantity, productId: productId, mainProductKey: mainProductKey, oldValue: oldValue});



    cartLoadingSpinner__active()

    if (isIncrease) {
      const diffrence = Number(subItem__newQuantity) - Number(oldValue) 

      const updatedCart = await fetch("/cart.js").then(r => r.json());

      // Find the item with _source and get its value (if any)
      const abTestSource = updatedCart.items.find(
        item => item.properties?._source
      )?.properties?._source;
        
      await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          items: Array.from({ length: diffrence }, () => ({
            id: productId,
            quantity: 1,
            properties: { 
              _main_product_key: Math.random().toString(36).substring(2, 15),
              ...(abTestSource && { _source: abTestSource })
            }
          }))
        }),
      })          
      .then((response) => response.json())
      .then(async () => {
        // Fetch updated cart to get item count
        const updatedCart = await fetch("/cart.js").then((r) =>
          r.json()
        );
        // Dispatch cart:update event - this will trigger both cart items and bubble to update
        document.dispatchEvent(
          new CustomEvent("cart:update", {
            bubbles: true,
            detail: {
              resource: updatedCart,
              sourceId: "cart__additional-test-checkbox",
              data: {
                source: "cart__additional-test-checkbox",
                itemCount: updatedCart.item_count,
              },
            },
          })
        );
      });

    } else {
      // Decreasing - need to remove items
      const difference = Number(oldValue) - Number(subItem__newQuantity);
      // Decreasing - need to remove items
      try {
        // Get current cart
        const cartResponse = await fetch('/cart.js');
        const cart = await cartResponse.json();

        // Filter items that match the productId (convert both to numbers for comparison)
        const matchingItems = cart.items.filter(item => Number(item.id) === Number(productId));

        //console.log("Matching items found:", matchingItems.length);

        // Get the last 'difference' number of items to remove
        // Reverse the array, take the first N items, then reverse back
        const itemsToRemove = matchingItems.reverse().slice(0, difference);

        //console.log("Items to remove:", itemsToRemove);

        // Create updates object with all items to remove at once
        const updates = {};
        itemsToRemove.forEach(item => {
          updates[item.key] = 0;
        });

        // Remove all items in one request
        await fetch("/cart/update.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ updates }),
        })      
        .then((response) => response.json())
        .then(async () => {
          // Fetch updated cart to get item count
          const updatedCart = await fetch("/cart.js").then((r) =>
            r.json()
          );
          // Dispatch cart:update event - this will trigger both cart items and bubble to update
          document.dispatchEvent(
            new CustomEvent("cart:update", {
              bubbles: true,
              detail: {
                resource: updatedCart,
                sourceId: "cart__additional-test-checkbox",
                data: {
                  source: "cart__additional-test-checkbox",
                  itemCount: updatedCart.item_count,
                },
              },
            })
          );
        });
      } catch (error) {
        console.error("Error removing items from cart:", error);
      }    
    } 
    cartLoadingSpinner__deactivate()
  }
});


// Helper function to dispatch cart update event
function dispatchCartUpdate(updatedCart, sections = null) {
  console.log("sections: ", sections)
  document.dispatchEvent(
    new CustomEvent("cart:update", {
      bubbles: true,
      detail: {
        resource: updatedCart,
        sourceId: "cart__additional-test-checkbox",
        data: {
          source: "cart__additional-test-checkbox",
          itemCount: updatedCart.item_count,
          sections
        },
      },
    })
  );
}

function getCartSectionId() {
  return document.querySelector('cart-items-component')?.dataset.sectionId;
}

let cartBusy = false;
document.addEventListener("change", async (event) => {
  const checkbox = event.target;

  if (!checkbox.matches('[id^="cart__additional-test-checkbox"]')) return;

  const row = checkbox.closest(".cart-items__table-row");
  if (!row) return;

  if (cartBusy) return;          // Sperre, unabhängig vom DOM
  cartBusy = true;

  cartLoadingSpinner__active();

  try {
    const isChecked = checkbox.checked;
    const { productid: subProductId, productkey, mainproductkey: mainProductKey, bundlekey: bundleKey } = checkbox.dataset;

    const cartResponse = await fetch("/cart.js");
    const cart = await cartResponse.json();

    const mainItem = cart.items.find((i) => i.key === mainProductKey);
    const sectionId = getCartSectionId();
    let sections = null;

    // REMOVE: Uncheck removes the item
    if (!isChecked) {
      const res = await fetch("/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          id: productkey,
          quantity: 0,
          sections: sectionId,                 
          sections_url: window.location.pathname,
        }),
      });

      const data = await res.json();
      sections = data.sections[sectionId];

      const updatedCart = await fetch("/cart.js").then((r) => r.json());
      dispatchCartUpdate(updatedCart, sections);
      return;
    }

    // ADD: Check adds the item
    if (!mainItem) {
      console.warn(`Main product with key ${mainProductKey} not found in cart.`);
      return;
    }



    // CASE 1: No bundle exists - create one
    if (mainItem.has_components === false) {
      const randomKey = mainProductKey + Math.floor(1000 + Math.random() * 9000);

      // Update main product with bundle key
      await fetch("/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          id: mainItem.key,
          quantity: mainItem.quantity,
          properties: {
            _main_product_key: randomKey,
          },
        }),
      });

      // Add sub-product linked to bundle
      const res = await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          id: subProductId,
          quantity: 1,
          properties: {
            _blongs_to_main_product_key: randomKey,
          },
          sections: sectionId,                 
          sections_url: window.location.pathname,
        }),
      });

      const data = await res.json(); 
      console.log(data);
      sections = data.sections[sectionId];
    }
    // CASE 2: Bundle exists - add to existing bundle
    else if (mainItem.has_components === true) {
      const res = await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          id: subProductId,
          quantity: 1,
          properties: {
            _blongs_to_main_product_key: bundleKey,
          },
                  sections: sectionId,                 
          sections_url: window.location.pathname,
        }),
      });

      const data = await res.json(); 
            console.log(data);
      sections = data.sections[sectionId];
    }

    const updatedCart = await fetch("/cart.js").then((r) => r.json());
    dispatchCartUpdate(updatedCart, sections);
  } catch (error) {
    console.error("Error handling checkbox logic:", error);
  } finally {
    cartLoadingSpinner__deactivate();
     cartBusy = false; // NEU: am Ende wieder freigeben
  }
});

// REMOVE ALL BUNDLE PRODUCTS BY ID
document.addEventListener('click', async function(e) {
    
  // Check if the clicked element OR its parent is the remove button
  const button = e.target.closest('.cart-items__remove--custom-bundle');
  
  if (button) {
    
    const productId = button.dataset.productid;
    
    if (!productId) {
      console.error('No product ID found');
      return;
    }
    
    //console.log('Product ID:', productId); // Debug

    cartLoadingSpinner__active();
    try {
      // Get current cart
      const cartResponse = await fetch('/cart.js');
      const cart = await cartResponse.json();
      
      // Filter items that match the productId
      const matchingItems = cart.items.filter(item => Number(item.product_id) === Number(productId));
      
      //console.log(`Found ${matchingItems.length} items to remove`);
      
      if (matchingItems.length === 0) {
        return;
      }
      
      // Create updates object to remove all matching items
      const updates = {};
      matchingItems.forEach(item => {
        updates[item.key] = 0;
      });
      
      // Remove all items in one request
      await fetch("/cart/update.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ updates }),
      })          
      .then((response) => response.json())
      .then(async () => {
        // Fetch updated cart to get item count
        const updatedCart = await fetch("/cart.js").then((r) =>
          r.json()
        );
        // Dispatch cart:update event - this will trigger both cart items and bubble to update
        document.dispatchEvent(
          new CustomEvent("cart:update", {
            bubbles: true,
            detail: {
              resource: updatedCart,
              sourceId: "cart__additional-test-checkbox",
              data: {
                source: "cart__additional-test-checkbox",
                itemCount: updatedCart.item_count,
              },
            },
          })
        );
      });
    } catch (error) {
      console.error("Error removing items from cart:", error);
    }
    cartLoadingSpinner__deactivate()
  }
});

// GO TO CHECKOUT
document.addEventListener("click", async (event) => {
  const checkoutButton = event.target.closest("#CartPage-Checkout");
  if (!checkoutButton) return;

  event.preventDefault();

  // Prevent double-click / double execution
  if (checkoutButton.dataset.processing === "true") return;
  checkoutButton.dataset.processing = "true";

  cartLoadingSpinner__active();

  try {
    const cartResponse = await fetch("/cart.js");
    const cart = await cartResponse.json();

    const rows = document.querySelectorAll(".cart-items__test-contaner");

    for (const row of rows) {
      const itemKey = row.dataset.itemkey;
      if (!itemKey) continue;

      const nameInput = row.querySelector(".cart-items__name-input-field");
      if (!nameInput) continue;

      const inputValue = nameInput.value.trim();
      if (!inputValue) continue;

      const lineItem = cart.items.find(item => item.key === itemKey);
      if (!lineItem) continue;

      const mergedProperties = {
        ...(lineItem.properties || {})
      };

      // If you plan multiple rows later, this is already future-proof
      const rowIndex = nameInput.dataset.row || "1";
      mergedProperties[`_row_name_${rowIndex}`] = inputValue;

      await fetch("/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          id: lineItem.key,
          quantity: lineItem.quantity,
          properties: mergedProperties,
        }),
      });
    }

    await fixAddonQuantities();

    window.location.href = "/checkout";
  } catch (error) {
    console.error("Checkout preparation failed:", error);
    checkoutButton.dataset.processing = "false";
    cartLoadingSpinner__deactivate();
  }
});


// PreSave Test name
document.addEventListener("focusout", async (event) => {
  const input = event.target.closest(".cart-items__name-input-field");
  if (!input) return;

  const row = input.closest(".cart-items__test-contaner");
  if (!row) return;

  const itemKey = row.dataset.itemkey;
  if (!itemKey) return;

  const value = input.value.trim();
  if (!value) return;

  // Fetch cart once
  const cartResponse = await fetch("/cart.js");
  const cart = await cartResponse.json();

  const lineItem = cart.items.find(item => item.key === itemKey);
  if (!lineItem) return;

  const propKey = `_row_name_1`;

  if (lineItem.properties?.[propKey] === value) return;

  // Merge existing properties first (like the reference code)
  const mergedProperties = {
    ...(lineItem.properties || {})
  };
  
  // Then add the new property
  mergedProperties[propKey] = value;

  await fetch("/cart/change.js", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      id: lineItem.key,
      quantity: lineItem.quantity,
      properties: mergedProperties,
    }),
  });
});

// Listen for BFCache restore -> cart page bug
window.addEventListener('pageshow', function(event) {
  // Only run on the cart page
  if (!window.location.pathname.endsWith('/cart')) return;

  const navType = performance.getEntriesByType('navigation')[0]?.type;

  if (navType === 'back_forward' || event.persisted) {
    // Force immediate reload - faster and no flash of stale content
    window.location.reload();
  }
});


/* ---- CUSTOM cart:update ---- */
document.addEventListener("DOMContentLoaded", () => {
  fixAddonQuantities();

  document.addEventListener("cart:update", async () => {
    await fixAddonQuantities();
  });
});

async function fixAddonQuantities() {
  /*console.log('[BundleGuard] init');*/
  const CHECKBOX_SELECTOR = '[id^="cart__additional-test-checkbox"]';
  const checkboxes = document.querySelectorAll(CHECKBOX_SELECTOR);
  if (!checkboxes.length) return;

  for (const checkbox of checkboxes) {
    if (!checkbox.checked) continue;

    const dataQuantity = parseInt(checkbox.dataset.quantity, 10);
    if (dataQuantity <= 1) continue;

    const { productkey } = checkbox.dataset;

    console.warn(`[BundleGuard] Addon ${productkey} has data-quantity ${dataQuantity}, correcting to 1`);
    cartLoadingSpinner__active();

    try {
      await fetch("/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: productkey, quantity: 0 }),
      })

      // Uncheck and click to re-add cleanly at qty 1
      checkbox.checked = false;
      checkbox.click();

    } catch (err) {
      console.error("[BundleGuard] Failed to correct addon quantity:", err);
    } finally {
      cartLoadingSpinner__deactivate();
    }
  }

  const cart = await fetch("/cart.js").then((r) => r.json());

  const subProducts = cart.items.filter((item) =>
    item.properties && (
      item.properties["_sub_product"] !== undefined ||
      item.properties["_blongs_to_main_product_key"] !== undefined
    )
  );

  if (!subProducts.length) return;

  for (const item of subProducts) {
    console.warn(`[BundleGuard] Sub-product found: ${item.key}, setting to 0`);
    cartLoadingSpinner__active();

    try {
      await fetch("/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: item.key, quantity: 0 }),
      })
        .then((response) => response.json())
        .then(async () => {
          const updatedCart = await fetch("/cart.js").then((r) => r.json());
          document.dispatchEvent(
            new CustomEvent("cart:update", {
              bubbles: true,
              detail: {
                resource: updatedCart,
                sourceId: "BundleGuard",
                data: {
                  source: "BundleGuard",
                  itemCount: updatedCart.item_count,
                },
              },
            })
          );
        });
    } catch (err) {
      console.error("[BundleGuard] Failed to remove sub-product:", err);
    } finally {
      cartLoadingSpinner__deactivate();
    }
  }
}